/* eslint-disable class-methods-use-this */
import Popup from './popup';

export default class CourseCreationDetailPopup extends Popup {
  createComponent() {
    return document.createElement(`au-${this.type}`);
  }

  setAttributes(
    courseCreationDetailPopup,
    courseEditDetails,
    trackSemanticName
  ) {
    try {
      courseCreationDetailPopup.setAttribute(
        'univ-semantic-name',
        this.pathQueryMap.pathMap.univ
      );

      courseCreationDetailPopup.setAttribute(
        'track-semantic-name',
        trackSemanticName
      );

      courseCreationDetailPopup.setAttribute('mode', courseEditDetails.mode);

      courseCreationDetailPopup.setAttribute('view', courseEditDetails.view);

      courseCreationDetailPopup.setAttribute(
        'course-semantic-name',
        courseCreationDetailPopup._course.semanticName
      );
    } catch (err) {
      console.error(`Exception while setting attributes :: ${err}`);
    }
  }
}
